import { createSelector } from 'reselect'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current/index.js'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'
import { USER_KEY } from '@gymaholic/packages'

export const getFreeTrialStartedAtUserSelect = createSelector(
  getCurrentTrainingUserSelect,
  (user) => getValueReduxUtil(user, USER_KEY.SUBSCRIPTION_FREE_TRIAL_STARTED_AT)
)
